<template>
  <div class="px-5 pt-5">
    <b-card>
      <b-card-body>
        <div class="row">
          <div class="col-12">
            <h4 class="text-primary mb-3">Lote</h4>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Funcionario creador</strong>
              <div class="ml-3">
                {{ batch.usuarioNombre }}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Folio</strong>
              <div class="ml-3">
                {{ batch.folio }}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Número interno</strong>
              <div class="ml-3">
                {{ batch.numeroInterno }}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Estado</strong>
              <div class="ml-3">
                <vs-chip
                  :color="batchesStates[batch.estado].color"
                  v-if="batchesStates[batch.estado]"
                  v-tooltip="`${batchesStates[batch.estado].label}`"
                >
                  {{batchesStates[batch.estado].label}}
                </vs-chip>
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Ex Lote</strong>
              <div class="ml-3">
            <span v-if="batch.esExLote == IS_EXISTING_BATCH">
              Si
            </span>
                <span v-if="batch.esExLote == IS_NOT_EXISTING_BATCH">
              No
            </span>
              </div>
            </div>
          </div>
          <div class="col-6 mt-3" v-if="batch.motivoDevolucion">
            <div>
              <strong>Motivo devolución</strong>
              <div class="ml-3">
            <span>
              {{ batch.motivoDevolucion }}
            </span>
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Aduana Loteadora</strong>
              <div class="ml-3">
                {{ batch.loteadoraDescripcion }}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Requiere VB</strong>
              <div class="ml-3">
            <span v-if="batch.requiereVb == NO_APPROVAL_REQUIRED">
              No
            </span>
                <span v-if="batch.requiereVb == YES_APPROVAL_REQUIRED">
              Si
            </span>
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Fecha de emisión</strong>
              <div class="ml-3">
                {{ batch.fechaCreacion | dateFormat }}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Monto mínimo</strong>
              <div class="ml-3">
                ${{ batch.montoMinimo }}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Clasificación de lote</strong>
              <div class="ml-3">
                {{ batch.clasificacionLoteDescripcion }}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Tipo de medida</strong>
              <div class="ml-3">
                {{ batch.tipoMedidaDescripcion }}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Peso</strong>
              <div class="ml-3">
                {{ batch.pesoLote }}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Unidad de medida</strong>
              <div class="ml-3">
                {{ batch.unidadMedidaDescripcion }}
              </div>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
    <b-card>
      <b-card-body>
        <div class="row">
          <div class="col-12">
            <h4 class="text-primary mb-3">Jurídica</h4>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Calidad jurídica</strong>
              <div class="ml-3">
                {{ batch.calidadJuridicaNombre }}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Fecha de presunción</strong>
              <div class="ml-3">
                {{ batch.fechaPresuncion | dateFormat }}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Fecha de incautación</strong>
              <div class="ml-3">
                {{ batch.fechaIncautacion | dateFormat }}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Causa Art. Ord. 136</strong>
              <div class="ml-3">
                {{ batch.causaArtOrd }}
              </div>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
    <b-card>
      <b-card-body>
        <div class="row">
          <div class="col-12">
            <h4 class="text-primary mb-3">Mercancía</h4>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Consignatorio</strong>
              <div class="ml-3">
                {{ batch.consignatorio }}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Fecha de loteo</strong>
              <div class="ml-3">
                {{ batch.fechaLoteo | dateFormat }}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Ubicación de mercancía</strong>
              <div class="ml-3">
                {{ batch.ubicacionMercanciaDescripcion || '-' }}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Calidad de mercancía</strong>
              <div class="ml-3">
                {{ batch.calidadMercanciaValor || '-' }}
              </div>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
    <b-card v-if="batch.estado === batchesCodeSates.rescatado">
      <b-card-body>
        <div class="row">
          <div class="col-12">
            <h4 class="text-primary mb-3">Rescate</h4>
          </div>
          <div class="col-6 mt-3" v-if="batch.f09Numero">
            <div>
              <strong>F-09</strong>
              <div class="ml-3">
                {{ batch.f09Numero }}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3" v-if="batch.f09FechaPago">
            <div>
              <strong>Fecha de pago</strong>
              <div class="ml-3">
                {{ batch.f09FechaPago }}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3" v-if="batch.f09MontoPago">
            <div>
              <strong>Monto cancelado</strong>
              <div class="ml-3">
                {{ batch.f09MontoPago }}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3" v-if="batch.rescateFechaResolucion">
            <div>
              <strong>Fecha Resolución</strong>
              <div class="ml-3">
                {{ batch.rescateFechaResolucion }}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3" v-if="batch.rescateNumeroResolucion">
            <div>
              <strong>Número resolución</strong>
              <div class="ml-3">
                {{ batch.rescateNumeroResolucion }}
              </div>
            </div>
          </div>
          <div class="col-12 mt-3">
            <div>
              <strong>Motivo rescate</strong>
              <div class="ml-3 mr-4 text-justify">
                {{ batch.rescateMotivo || '-' }}
              </div>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
    <b-card>
      <b-card-body>
        <div class="row">
          <div class="col-12">
            <h4 class="text-primary mb-3">Descripción y adicionales</h4>
          </div>
          <div class="col-12 mt-3">
            <div>
              <strong>Descripción del lote</strong>
              <div class="ml-3 container-description text-justify">
                {{ batch.descripcionLote }}
              </div>
            </div>
          </div>
          <div class="col-12 mt-3">
            <div>
              <strong>Datos adicionales internos</strong>
              <div class="ml-3 mr-4 text-justify">
                {{ batch.descripcionLoteFactura }}
              </div>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
    <div class="row mb-5 px-5" v-if="batchImages.length">
      <div class="col-12 mt-3 mb-3">
        <h5 class="text-primary">Imágenes del lote</h5>
        <div class="row">
          <img
            v-for="image in batchImages" :key="image.imagenId"
            :src="image.urlImagen"
            alt="logo"
            class="col-4 mt-2 mr-2 cursor-pointer img-batch"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex';

import {
  batchesStates,
  IS_NOT_EXISTING_BATCH,
  IS_EXISTING_BATCH,
  NO_APPROVAL_REQUIRED,
  YES_APPROVAL_REQUIRED,
  batchesCodeSates
} from '@/febos/aduanas/batches/views/utils/constants';
import { getBatch } from '@/febos/servicios/api/aduanas/batches.api';
import { selectedBatch } from '@/febos/aduanas/batches/store/getters';

export default {
  name: 'BatchDetail',
  data() {
    return {
      batchImages: [],
      batchesStates,
      IS_NOT_EXISTING_BATCH,
      IS_EXISTING_BATCH,
      NO_APPROVAL_REQUIRED,
      YES_APPROVAL_REQUIRED,
      batchesCodeSates
    };
  },
  props: ['batch'],
  computed: {
    ...mapGetters('batches', {
      selectedBatch: selectedBatch.name
    })
  },
  async created() {
    const response = await getBatch({ loteId: this.selectedBatch });
    this.batchImages = response.data.imagenes;
  }
};
</script>
<style>
.container-description{
  max-height: 250px;
  overflow-y: scroll;
}
.img-batch {
  width: 200px;
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
}
</style>
